import { Card, CardBody, CardHeader, Heading } from 'grommet';
import { PropsWithChildren, ReactNode } from 'react';

export type ModalInfoCardProps = PropsWithChildren & {
  title: ReactNode;
};

export const ModalInfoCard = ({ title, children }: ModalInfoCardProps) => {
  return (
    <Card background="light-2" round="small" elevation="none" border={{ size: '1px', color: 'light-4' }}>
      <CardHeader
        background="white"
        border={{ side: 'bottom', color: 'border-divider' }}
        height="42px"
        pad={{ horizontal: 'medium' }}
      >
        <Heading level={4} margin="none" color="text-heading">
          {title}
        </Heading>
      </CardHeader>

      <CardBody pad="small" background="light-2">
        {children}
      </CardBody>
    </Card>
  );
};
